import { matchPath } from "react-router-dom";

export interface RouteHeading {
  title: string;
  subtitle?: string;
}

/** Título/subtítulo exibidos na topbar, por rota. Primeiro match vence. */
const ROUTE_HEADINGS: Array<{ pattern: string; heading: RouteHeading }> = [
  { pattern: "/dashboard/app", heading: { title: "Início", subtitle: "Resumo da sua atividade" } },
  { pattern: "/dashboard/cleo", heading: { title: "Cléo", subtitle: "Sua assistente de formulação" } },
  { pattern: "/dashboard/query/*", heading: { title: "Nova consulta", subtitle: "Monte uma fórmula personalizada" } },
  { pattern: "/dashboard/query", heading: { title: "Nova consulta", subtitle: "Monte uma fórmula personalizada" } },
  { pattern: "/dashboard/dose", heading: { title: "Nova consulta", subtitle: "Defina as concentrações" } },
  { pattern: "/dashboard/doseOral", heading: { title: "Nova consulta", subtitle: "Defina as dosagens" } },
  { pattern: "/dashboard/reviewConsult/:id", heading: { title: "Revisão da consulta" } },
  { pattern: "/dashboard/reviewOral/:id", heading: { title: "Revisão da consulta" } },
  { pattern: "/dashboard/history", heading: { title: "Histórico", subtitle: "Suas consultas realizadas" } },
  { pattern: "/dashboard/patients/*", heading: { title: "Pacientes", subtitle: "Gestão de pacientes" } },
  { pattern: "/dashboard/patients", heading: { title: "Pacientes", subtitle: "Gestão de pacientes" } },
  { pattern: "/dashboard/actives", heading: { title: "Ativos", subtitle: "Biblioteca de ativos" } },
  { pattern: "/dashboard/pricing", heading: { title: "Planos", subtitle: "Escolha o plano ideal para você" } },
  { pattern: "/dashboard/planHistory", heading: { title: "Histórico de planos", subtitle: "Suas assinaturas e pagamentos" } },
  { pattern: "/dashboard/profile", heading: { title: "Meu perfil", subtitle: "Dados pessoais e da conta" } },
  { pattern: "/dashboard/tutorial", heading: { title: "Tutoriais", subtitle: "Aprenda a usar a plataforma" } },
  { pattern: "/dashboard/support", heading: { title: "Suporte", subtitle: "Como podemos ajudar?" } },
  { pattern: "/adm", heading: { title: "Início", subtitle: "Visão geral do backoffice" } },
  { pattern: "/adm/users", heading: { title: "Usuários", subtitle: "Gestão de usuários da plataforma" } },
  { pattern: "/adm/actives", heading: { title: "Gestão de Classes", subtitle: "Classes de ativos do catálogo." } },
  { pattern: "/adm/subclass", heading: { title: "Subclasses", subtitle: "Gestão de subclasses" } },
  { pattern: "/adm/products", heading: { title: "Ativos", subtitle: "Gestão do catálogo de ativos" } },
  { pattern: "/adm/oral", heading: { title: "Produtos orais", subtitle: "Nutricosméticos e produtos de uso oral." } },
  { pattern: "/adm/vehicles", heading: { title: "Veículos", subtitle: "Gestão de veículos" } },
  { pattern: "/adm/plans", heading: { title: "Planos", subtitle: "Gestão de planos" } },
  { pattern: "/adm/gifts", heading: { title: "Brindes", subtitle: "Gestão de presentes" } },
  { pattern: "/adm/DCO", heading: { title: "DCO", subtitle: "E-mails DCO" } },
  { pattern: "/adm/tutorial", heading: { title: "Mídia", subtitle: "Gestão de vídeos e tutoriais" } },
  { pattern: "/adm/cupom", heading: { title: "Cupons", subtitle: "Gestão de cupons" } },
  { pattern: "/adm/feature-flags", heading: { title: "Feature flags", subtitle: "Liga/desliga de funcionalidades" } },
  { pattern: "/adm/ai-experiments", heading: { title: "Experimentos de IA", subtitle: "Testes A/B da Cléo" } },
];

const DEFAULT_HEADING: RouteHeading = { title: "ProAtivos" };

export function getRouteHeading(pathname: string): RouteHeading {
  const found = ROUTE_HEADINGS.find(({ pattern }) =>
    matchPath({ path: pattern, end: true }, pathname)
  );
  return found?.heading ?? DEFAULT_HEADING;
}
